export default __webpack_public_path__ + "static/media/Brooke Fleming.6b535858.png";